import $ from 'jquery';
import AjaxRequest from "../modules/ajax-request";

class AccountSearchFavoriteArticles {
    constructor(element) {
        this.searchForm = element;
        this.searchButton = $('[data-id="button"]');
        this.searchAction = $(this.searchForm).data('action');

        this.bindEvents();
    }
    bindEvents() {
        var _this = this;
        (this.searchButton).on("click", function (event) {
            _this.submitSearchForm(event);
        });
    }
    submitSearchForm(event) {
        event.preventDefault();
        var text = document.getElementById("searchInput").value;
        var _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(this.searchForm).removeClass("loading");
                $('[data-id="list-items"]').html(response.listSearchedFavoritesHtml);
            },
            errorCallback: function (response) {
                $(this.searchForm).removeClass("loading");
            }
        });
        $(this.searchForm).addClass("loading");
        _ajaxRequest.makeCall(this.searchAction + '&text=' + text);
    }
}

export default AccountSearchFavoriteArticles;